// The P1 SEO copy for / and /ux-auditor/ (owner, 2026-10-07). CLAUDE.md:
// anything touching those two pages ships behind a preview route first, and the
// owner rules on the rendered page. Until then the new copy renders only at
// /home-preview/ and /ux-auditor-preview/ (noindex, canonical to the live URL,
// out of the sitemap). Cutover is this flag: true puts the new copy on the live
// pages and retires both preview routes (scripts/lib/public-routes.mjs reads it).
export const SEO_P1_LIVE = true;
